import { Directive } from '@angular/core';

@Directive({
  selector: '[xpoChipSmall]',
  host: { class: 'xpo-Chip--small' },
})
export class XpoChipSmall {}
